import queries from '@nc-aftermarket/config/queryDefs';
import Meta from '../components/Meta';
import { SaleTableColumnSets } from '../components/SaleTable.columns';
import SaleTablePage from '../components/SaleTablePage';

export default function Auctions() {
  return (
    <>
      <Meta
        canonical="https://www.namecheap.com/market/"
        description="Discover domains for sale in our Domain Auctions. Find the perfect name for your brand, and try domain name bidding today."
        robots="all"
        title="Bid On Domain Names | Domain Name Auctions - Namecheap"
      />
      <SaleTablePage
        pollInterval={5 * 60 * 1000}
        query={queries.SaleTable}
        queryVars={{ filter: { saleType: 'auction' } }}
        title="Auctions"
        visibleColumns={SaleTableColumnSets.auction}
      />
      <div className="tw-text-sm tw-text-center tw-pb-8 tw-leading-tight">
        <a href="https://aftermarket-react-app.s3.amazonaws.com/Namecheap_Market_Sales.csv">
          Export all current domain auctions to CSV
        </a>{' '}
        <small className="tw-text-xs tw-whitespace-nowrap">
          (Updates once per hour)
        </small>
      </div>
    </>
  );
}
